var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.166992 21.5C0.166992 19.3783 1.00985 17.3434 2.51014 15.8431C4.01043 14.3429 6.04526 13.5 8.16699 13.5C10.2887 13.5 12.3236 14.3429 13.8238 15.8431C15.3241 17.3434 16.167 19.3783 16.167 21.5H0.166992ZM8.16699 12.5C4.85199 12.5 2.16699 9.815 2.16699 6.5C2.16699 3.185 4.85199 0.5 8.16699 0.5C11.482 0.5 14.167 3.185 14.167 6.5C14.167 9.815 11.482 12.5 8.16699 12.5ZM15.53 14.733C17.0596 15.1261 18.4263 15.9918 19.4353 17.2068C20.4444 18.4218 21.0444 19.9242 21.15 21.5H18.167C18.167 18.89 17.167 16.514 15.53 14.733ZM13.507 12.457C14.345 11.7075 15.0151 10.7893 15.4736 9.76275C15.932 8.73616 16.1683 7.62429 16.167 6.5C16.1691 5.13347 15.8196 3.78937 15.152 2.597C16.2846 2.82459 17.3035 3.43737 18.0354 4.3312C18.7674 5.22502 19.1672 6.34473 19.167 7.5C19.1673 8.21247 19.0152 8.91676 18.7211 9.56567C18.427 10.2146 17.9975 10.7931 17.4615 11.2625C16.9256 11.7319 16.2955 12.0814 15.6134 12.2874C14.9314 12.4934 14.2132 12.5512 13.507 12.457Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasual);
export default __webpack_public_path__ + "static/media/casual.c1778c00cf97a3cd683b847f7a2db88b.svg";
export { ForwardRef as ReactComponent };